import React, { useRef } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
// import create from 'zustand'
import { ProjectProvider } from '@vt/hooks'
import { getQuery, routeTo } from '@vt/utils'
import { ThemeProvider, ErrorFallback, Toast } from '@ow/comps'
import { useCustomInfoSWR } from '@vt/apis/lib-ex/v2/login'
import { userLogout } from '@vt/apis/lib-ex/v2/users'
// import ErrorFallback from '../error-fallback'

import '@ow/comps/dist/style.css'
import '@ow/comps/dist/font.css'
import '@ow/comps/dist/scrollbar.css'

// const defaultCustomStore = () =>
//   create(() => {
//     return {
//       // OperateComponent: <div>操作</div>,
//     }
//   })

const DEP_ENV = process.env.REACT_APP_DEP
const RAP = process.env.REACT_APP_PROJECT

// 自定义跳转登录页面
const logOut = (vtProject, tpl) => {
  if (window.location.pathname.match(/\/login/)) {
    return
  }
  userLogout()
  vtProject.deleteStorage()
  if (tpl === 'yyzcjc') {
    const loginUrl =
      DEP_ENV === 'dev'
        ? 'https://testagent.sinooceangroup.com:8443/THRWebApp/passport-public/passport.htm?client_id=policymonitoring&redirect_uri=http://sinoocean-dev.survey.work?key=yyzcjc&response_type=code#/logout'
        : 'https://workflow.sinooceangroup.com/THRWebApp/passport.htm?client_id=Contacts&redirect_uri=http://sinoocean.survey.work?key=yyzcjc&response_type=code#/logout'
    window.location.href = loginUrl
  } else if (RAP.indexOf('voltali') !== -1) {
    routeTo(`/login?key=${tpl}`)
  } else {
    routeTo(`/cp/${RAP}/login?key=${tpl}`)
  }
}

// 默认接口错误处理
const defaultErrorHandler = {
  400: (msg) => {
    Toast.error({
      title: '请求异常',
      description: msg,
      duration: 3000,
    })
  },
  500: (msg) => {
    Toast.error({
      title: '请求异常',
      description: msg,
      duration: 3000,
    })
  },
  default: (msg) => {
    Toast.error({
      title: '请求异常',
      description: msg,
      duration: 3000,
    })
  },
}

const App = function ({
  children,
  vtProject,
  customCompsMap,
  style,
  customKey,
}) {
  const { token, key, tpl } = getQuery()
  const { customInfo } = useCustomInfoSWR(customKey || key || tpl)
  const warpperRef = useRef()

  if (token) {
    // 优先使用url的token，并更新storage
    vtProject.setToken(token)
    vtProject.setStorage({ key: 'token', data: token })
  } else {
    // 如果url的token不存在，尝试使用storage的token
    const storageToken = vtProject.getStorage('token')
    vtProject.setToken(storageToken)
  }

  vtProject.http.setErrorCallback({
    ...defaultErrorHandler,
    401: (msg) => {
      Toast.error({
        title: msg,
        description: '请重新登录系统',
        duration: 4000,
      })
      setTimeout(() => {
        logOut(vtProject, tpl)
      }, 3000)
    },
  })

  const cusKey = customKey || key || tpl
  vtProject.setCusKey(cusKey)

  return (
    <div
      className="App font-hei h-screen flex"
      ref={warpperRef}
      style={{ background: '#E9EAEE', ...style }}
    >
      <ThemeProvider theme={customInfo.custom_theme}>
        <ErrorBoundary FallbackComponent={ErrorFallback}>
          <ProjectProvider
            value={{
              token,
            }}
            warpperRef={warpperRef}
            cusKey={cusKey}
            vtProject={vtProject}
            customCompsMap={customCompsMap || {}}
          >
            {children}
          </ProjectProvider>
        </ErrorBoundary>
      </ThemeProvider>
    </div>
  )
}
export default App
